
import axios from "axios";
import { getToken, getTokenn } from "./auth";
import "./restricaoPermissao.scss";

// ==========================================================
// INSTÂNCIA AXIOS DA API INOVA
// ==========================================================

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// ==========================================================
// CONTROLE DO ALERTA DE PERMISSÃO
// ==========================================================

let alertaPermissaoAberto = false;
let elementoModal = null;
let temporizadorFechamento = null;

// ==========================================================
// FECHAR MODAL
// ==========================================================

function fecharAlertaPermissao() {
  if (!elementoModal || !alertaPermissaoAberto) return;

  const modal = elementoModal;
  alertaPermissaoAberto = false;

  if (temporizadorFechamento) {
    clearTimeout(temporizadorFechamento);
    temporizadorFechamento = null;
  }

  modal.classList.add("permissao-visualizacao-saindo");

  const popup = modal.querySelector(
    ".permissao-visualizacao-popup"
  );

  popup?.classList.add("permissao-visualizacao-saindo");

  temporizadorFechamento = window.setTimeout(() => {
    modal.remove();

    if (elementoModal === modal) {
      elementoModal = null;
    }

    temporizadorFechamento = null;
  }, 250);
}

// ==========================================================
// MOSTRAR MODAL
// ==========================================================

function mostrarAlertaPermissao() {
  if (alertaPermissaoAberto) return;

  alertaPermissaoAberto = true;

  const overlay = document.createElement("div");

  overlay.id = "inova-permissao-visualizacao";
  overlay.className = "permissao-visualizacao-overlay";

  overlay.innerHTML = `
    <div
      class="permissao-visualizacao-popup"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="permissao-visualizacao-titulo"
      aria-describedby="permissao-visualizacao-mensagem"
    >
      <div class="permissao-visualizacao-icone">
        <svg
          width="30"
          height="30"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M12 3L22 20H2L12 3Z"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linejoin="round"
          />
          <path
            d="M12 9V13"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
          />
          <circle
            cx="12"
            cy="16.5"
            r="1"
            fill="currentColor"
          />
        </svg>
      </div>

      <h2
        id="permissao-visualizacao-titulo"
        class="permissao-visualizacao-titulo"
      >
        Ação não permitida
      </h2>

      <p
        id="permissao-visualizacao-mensagem"
        class="permissao-visualizacao-mensagem"
      >
        Seu usuário possui permissão somente para visualização.
        Você não pode realizar alterações neste sistema.
      </p>

      <div class="permissao-visualizacao-acoes">
        <button
          type="button"
          class="permissao-visualizacao-botao"
        >
          Entendi
        </button>
      </div>
    </div>
  `;

  elementoModal = overlay;
  document.body.appendChild(overlay);

  // Fecha pelo botão Entendi.
  overlay
    .querySelector(".permissao-visualizacao-botao")
    .addEventListener("click", fecharAlertaPermissao);

  // Fecha ao clicar fora do card.
  overlay.addEventListener("mousedown", (event) => {
    if (event.target === overlay) {
      fecharAlertaPermissao();
    }
  });

  // Fecha com Escape.
  overlay._tratarTecla = (event) => {
    if (event.key === "Escape") {
      fecharAlertaPermissao();
    }
  };

  document.addEventListener("keydown", overlay._tratarTecla);

  // Remove o listener quando o modal for removido.
  const observer = new MutationObserver(() => {
    if (!document.body.contains(overlay)) {
      document.removeEventListener(
        "keydown",
        overlay._tratarTecla
      );

      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
  });

  overlay
    .querySelector(".permissao-visualizacao-botao")
    .focus();
}

// ==========================================================
// INTERCEPTOR DE REQUISIÇÃO
// ==========================================================

api.interceptors.request.use(
  (config) => {
    // ------------------------------------------------------
    // 1. AUTENTICAÇÃO
    // ------------------------------------------------------

    const token = getToken();
    const tokenn = getTokenn();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else if (tokenn) {
      config.headers.Authorization = `Bearer ${tokenn}`;
    }

    // ------------------------------------------------------
    // 2. IDENTIFICAÇÃO DA REQUISIÇÃO
    // ------------------------------------------------------

    const tipo = localStorage.getItem("tipo");
    const metodo = (config.method || "get").toLowerCase();

    // Remove query string e barra final para comparar a rota.
    const urlSemQuery = (config.url || "")
      .split("?")[0]
      .replace(/\/+$/, "");

    // Aceita /login ou uma URL completa terminando em /login.
    const ehLogin = /(?:^|\/)login$/i.test(urlSemQuery);

    // ------------------------------------------------------
    // 3. LIBERA LOGIN
    // ------------------------------------------------------

    // O login precisa funcionar mesmo para usuário tipo "v".
    // A requisição continua normalmente para a API.
    if (ehLogin && metodo === "post") {
      return config;
    }

    // ------------------------------------------------------
    // 4. MÉTODOS DE ESCRITA
    // ------------------------------------------------------

    const metodosDeEscrita = [
      "post",
      "put",
      "patch",
      "delete",
    ];

    // ------------------------------------------------------
    // 5. BLOQUEIO DE PERMISSÃO
    // ------------------------------------------------------

    if (
      tipo === "v" &&
      metodosDeEscrita.includes(metodo)
    ) {
      console.warn(
        `[INOVA] Requisição bloqueada: ${metodo.toUpperCase()}`,
        config.url
      );

      mostrarAlertaPermissao();

      const erro = new Error(
        "Acesso negado: usuário somente para visualização."
      );

      erro.code = "ERR_READ_ONLY";

      return Promise.reject(erro);
    }

    // ------------------------------------------------------
    // 6. REQUISIÇÃO PERMITIDA
    // ------------------------------------------------------

    return config;
  },

  (error) => Promise.reject(error)
);

// ==========================================================
// EXPORTAÇÃO
// ==========================================================

export default api;
